import { Configuration, PopupRequest } from '@azure/msal-browser';

// ============================================================
// MSAL Configuration — Azure AD / Entra ID
// ============================================================

export const msalConfig: Configuration = {
  auth: {
    clientId: '3cae89c8-9a81-41fa-a270-09b4bdfd2468',
    authority: 'https://login.microsoftonline.com/d4a68d86-c5cd-4cd8-82cb-53508d701f16',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

// App roles (must match what you created in Entra ID)
export const AppRoles = {
  ITAdmin:    'IT.Admin',
  ITApprover: 'IT.Approver',
  Director:   'Director',
  EMT:        'EMT',
} as const;

export type AppRole = typeof AppRoles[keyof typeof AppRoles];
